import { useQuery } from '@apollo/client/react';
import { Spinner } from '@optools/components/loading/spinner';
import { Card } from '@optools/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import { GET_PIPELINE_INPUT_CONFIGS } from '@optools/services/operator-gateway/pipeline-input-config/queries';
import { Region } from '@optools/services/operator-gateway/types/generated/graphql';
import { capitalize } from 'es-toolkit';

import { PipelineInputConfigDialog } from './pipeline-input-config-dialog';

export interface PipelineInputConfigTableProps {
  region: Region;
  venueId: number | undefined;
}

export function PipelineInputConfigTable({ region, venueId }: PipelineInputConfigTableProps) {
  const { data, loading } = useQuery(GET_PIPELINE_INPUT_CONFIGS, {
    skip: typeof venueId !== 'number',
    variables: { region, venueId: venueId ?? 0 },
  });

  const configs = data?.pipelineInputConfigs;
  const label = `pipeline-input-config-${region}-table`;

  return (
    <section>
      <Card>
        <h3 className="pt-2 pl-2 text-lg font-semibold" id={label}>
          {capitalize(region)}
        </h3>
        {loading ? (
          <div className="flex h-52 items-center justify-center">
            <Spinner />
          </div>
        ) : configs && configs?.length > 0 ? (
          <Table aria-labelledby={label} className="whitespace-nowrap" data-testid={label}>
            <TableHeader>
              <TableRow>
                <TableHead>ID</TableHead>
                <TableHead>Region</TableHead>
                <TableHead>Feed Type Code</TableHead>
                <TableHead>Input Label</TableHead>
                <TableHead>Category</TableHead>
                <TableHead className="sr-only">Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {configs.map((config) => {
                const { category, feedTypeCode, id, inputLabel, region } = config;
                return (
                  <TableRow key={id}>
                    <TableCell>{id}</TableCell>
                    <TableCell>{region}</TableCell>
                    <TableCell>{feedTypeCode}</TableCell>
                    <TableCell>{inputLabel}</TableCell>
                    <TableCell>{category}</TableCell>
                    <TableCell>
                      <PipelineInputConfigDialog config={config} />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <p>There are no input configs for this venue and region.</p>
        )}
      </Card>
    </section>
  );
}
